module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAAyklEQVQokY3OOwrCQBDG8b9BbDzFthYiWmnhg4DllttaeQg9gnfwAltuJ4iPwjaNaGxkbyE+gtgkEEMeO9XM8GPmqwWzlg/4RqglJeUBa2Ahrd5XwW/cj6XVpzL4Ss0DafWxCGZrKK3eukAAP3u5CCaXDy4QYCSt3rlAgIm0euMCAaau0Ok1QOACL8CwXoFCoGOEisou3oCuESqC4oznGD2TRd7rEOgZoT7ppQc0UvM9zvSHEtiM+yvQNkK987J4wBxYAX0j1KMgMz9aRjWpJxGYFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/更多.png
// module id = CIsR
// module chunks = 1